import classNames from "classnames/bind";
import Footer from "../components/Footer";
import gridStyle from "../components/Grid.module.css";
import Heading from "../components/Heading";
import Image from "../components/Image";
import Video from "../components/Video";
import Layout from "../components/Layout";
import styles from "./AboutPage.module.css";
import Carousel from "../components/Carousel";

function Section({ heading, html }) {
  return (
    <div className={classNames(styles.contentSection, gridStyle.grid)}>
      <p className={styles.subheading}>{heading}</p>
      <div className={styles.text} dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
}

function Media({ content }) {
  if (!content) return;
  if (content.type === "image_carousel_block") {
    return <Carousel items={content.value} />;
  } else if (content.type === "image_block") {
    return (
      <Image
        src={content.value.src}
        srcSet={content.value.srcSet}
        sizes="100vw"
        alt={content.value.title}
        width={800}
        height={450}
      ></Image>
    );
  } else if (content.type === "video_block") {
    return <Video src={content.value} />;
  }
}

export default function AboutPage({ coreData, pageData, pathName }) {
  return (
    <Layout coreData={coreData} theme="dark" pathName={pathName}>
      <div className={styles.introSection}>
        <Heading className={styles.introHeading}>{pageData.heading}</Heading>
      </div>
      <Section heading="About us" html={pageData.introText} />
      <Section heading="Clients" html={pageData.clientsText} />
      <Heading size="l" className={styles.foundedHeading}>
        Founded 2013
      </Heading>
      <div className={styles.mediaSection}>
        <Media content={pageData.media[0]} />
      </div>
      <Footer theme="dark" />
    </Layout>
  );
}
